import {Model, ModelMixin} from '../../common/model.class';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class InactiveLicensesInformation extends ModelMixin() implements Model<InactiveLicensesInformation> {

    TYPE = InactiveLicensesInformation;

    states: string[] = [];

    constructor(jsonData: any = {}) {
        super();
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/inactive/inactive-licenses-information.model.ts